<template>
    <div>
        <Sidebar />

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-request d-lg-inline-block" />
            <Header />

            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 form-request-content">
                            <div class="request-title">
                                <h1>Renouveler demande</h1>
                            </div>
                            <h3 class="title-content">Information salarié</h3>
                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                    name="exemption"
                                    method="post"
                                    enctype="multipart/form-data"
                                    novalidate="novalidate"
                                    class="needs-validation"
                                >
                                    <!-- Civility -->
                                    <label class="required-field-asterisks required" for="exemption_civility">
                                        Civilité
                                    </label>
                                    <select
                                        id="exemption_civility"
                                        required="required"
                                        class="form-control"
                                        :class="{ 'is-invalid': $v.formData.civility.$error }"
                                        @change="delayTouch($v.formData.civility)"
                                        v-model="formData.civility"
                                        :disabled="isGeneralInformationLocked && !civilityInitiallyEmpty"
                                    >
                                        <option value="">-- Choisir --</option>
                                        <option
                                            v-for="civility in civilities"
                                            :key="civility.id"
                                            :value="civility.label"
                                        >{{ civility.label }}</option>
                                    </select>
                                    <FormError
                                        error="Veuillez renseigner la civilité"
                                        v-if="!$v.formData.civility.required && $v.formData.civility.$dirty"
                                    />
                                    <FormError
                                        error="La civilité ne doit pas dépasser 20 caractères"
                                        v-if="!$v.formData.civility.maxLength && $v.formData.civility.$dirty"
                                    />
                                    <!-- Civility -->

                                    <!-- First Name -->
                                    <label class="required-field-asterisks required" for="exemption_first_name">
                                        Prénom
                                    </label>
                                    <input
                                        type="text"
                                        id="exemption_first_name"
                                        required="required"
                                        class="form-control form-control-lg"
                                        aria-describedby="first-name-error"
                                        :class="{ 'is-invalid': $v.formData.firstName.$error }"
                                        @input="delayTouch($v.formData.firstName)"
                                        placeholder="Prénom"
                                        v-model="formData.firstName"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <FormError error="Veuillez renseigner le prénom" v-if="$v.formData.firstName.$error" />
                                    <!-- First Name -->

                                    <!-- Last Name -->
                                    <label class="required-field-asterisks required" for="exemption_last_name">
                                        Nom
                                    </label>
                                    <input
                                        type="text"
                                        id="exemption_last_name"
                                        required="required"
                                        class="form-control form-control-lg"
                                        aria-describedby="last-name-error"
                                        :class="{ 'is-invalid': $v.formData.lastName.$error }"
                                        @input="delayTouch($v.formData.lastName)"
                                        placeholder="Nom"
                                        v-model="formData.lastName"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <FormError error="Veuillez renseigner le nom" v-if="$v.formData.lastName.$error" />
                                    <!-- Last Name -->

                                    <!-- Birth Name -->
                                    <label for="exemption_birth_name">
                                        Nom de naissance
                                    </label>
                                    <input
                                        type="text"
                                        id="exemption_birth_name"
                                        name="exemption[birth_name]"
                                        class="form-control form-control-lg"
                                        placeholder="Nom de naissance"
                                        v-model="formData.birthName"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <!-- Birth Name -->

                                    <!-- Email -->
                                    <label class="required-field-asterisks required" for="exemption_email">
                                        Email professionnel
                                    </label>
                                    <input
                                        type="email"
                                        id="exemption_email"
                                        name="exemption[email]"
                                        required="required"
                                        class="form-control form-control-lg"
                                        :class="{ 'is-invalid': $v.formData.email.$error }"
                                        @input="delayTouch($v.formData.email)"
                                        placeholder="Email"
                                        v-model="formData.email"
                                        :readonly="isGeneralInformationLocked"
                                    >
                                    <FormError error="Format de l'email incorrect" v-if="!$v.formData.email.email && $v.formData.email.$dirty" />
                                    <FormError error="Veuillez renseigner l’email" v-if="!$v.formData.email.required && $v.formData.email.$dirty" />
                                    <!-- Email -->

                                    <!-- Phone Number -->
                                    <!-- TODO::remove v-if when yousign will be available for exemption -->
                                    <div
                                        v-if="false"
                                        class="form-group"
                                    >
                                        <label for="phone">Téléphone</label>
                                        <div class="input-group" >
                                            <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="fas fa-phone" />
                                                    </span>
                                            </div>
                                            <masked-input
                                                type="tel"
                                                mask="\+\33 1 11 11 11 11"
                                                id="phone"
                                                class="form-control"
                                                :class="{ 'is-invalid': $v.formData.phoneNumber.$error }"
                                                @input="delayTouch($v.formData.phoneNumber)"
                                                v-model="formData.phoneNumber"
                                            />
                                        </div>
                                        <FormError
                                            error="Le numéro de téléphone doit contenir 11 chiffres"
                                            v-if="!$v.formData.phoneNumber.phoneLength && $v.formData.phoneNumber.$dirty"
                                        />
                                    </div>
                                    <!-- Phone Number -->

                                    <!-- Birth Date -->
                                    <div class="form-group">
                                        <label for="birthDate">Date de naissance</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt" />
                                                </span>
                                            </div>
                                            <masked-input
                                                type="text"
                                                id="birthDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.birthDate.$error }"
                                                @input="delayTouch($v.formData.birthDate)"
                                                v-model="formData.birthDate"
                                                :readonly="isGeneralInformationLocked"
                                            />
                                        </div>
                                        <FormError error="Format de date incorrect" v-if="$v.formData.birthDate.$error" />
                                    </div>
                                    <!-- Birth Date -->

                                    <!-- Employer -->
                                    <div v-if="effectiveDues.length > 0" class="form-group">
                                        <label class="required-field-asterisks" for="structure">
                                            Employeur
                                        </label>
                                        <select
                                            id="structure"
                                            class="form-control select2"
                                            v-model.number="formData.dueId"
                                            @change="handleEffectiveDueChange()"
                                        >
                                            <option
                                                v-for="(due, index) in effectiveDues"
                                                :key="index"
                                                :value="due.id"
                                            >
                                                {{ due.companyName }} - {{ due.siren ? due.siren : due.siret }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- Employer -->

                                    <!-- Beneficiary -->
                                    <div class="form-group" v-if="handledFields.beneficiary">
                                        <label class="required-field-asterisks" for="beneficiary">
                                            Status
                                        </label>
                                        <select
                                            id="beneficiary"
                                            class="form-control select2"
                                            :disabled="effectiveDues.length > 0 && !formData.dueId"
                                            v-model.number="formData.beneficiaryId"
                                            @change="handleBeneficiaryChange($event.target.value, enterpriseUuid, isRenew)"
                                        >
                                            <option
                                                v-for="(beneficiary, index) in beneficiaries"
                                                :key="index"
                                                :value="beneficiary.id"
                                                :data-code="beneficiary.code"
                                            >
                                                {{ beneficiary.exemptionStatusTitle }}
                                            </option>
                                        </select>
                                    </div>
                                    <!-- Beneficiary -->

                                    <!-- Reason -->
                                    <div id="reason_group" class="form-group box-body">
                                        <label class="required-field-asterisks">Motif</label>
                                        <div class="icheck-primary radioNewResquestReasons">
                                            <input
                                                type="radio"
                                                id="employeeChoice"
                                                value="0"
                                                name="reason"
                                                v-model="formData.exemptionReason.reasonId"
                                                class="form-check-input"
                                            >
                                            <label class="form-check-label" for="employeeChoice">
                                                <span class="radioLabel">Laisser le choix au salarié</span>
                                            </label>
                                        </div>
                                        <div
                                            class="icheck-primary radioNewResquestReasons"
                                            v-for="reason in particularCaseFilteredReasons"
                                            :key="reason.code"
                                        >
                                            <input
                                                type="radio"
                                                :id="reason.code"
                                                :value="reason.id"
                                                name="reason"
                                                v-model="formData.exemptionReason.reasonId"
                                                class="form-check-input"
                                            >
                                            <label class="form-check-label" :for="reason.code">
                                                <span class="radioLabel">{{ reason.titleHro }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <!-- Reason -->

                                    <!-- Reason Documents -->
                                    <ReasonDocuments
                                        :chosenReason.sync="chosenReason"
                                        :exemptionReason.sync="formData.exemptionReason"
                                        :expirationDate.sync="formData.exemptionReason.expirationDate"
                                        :exemptionStartDate="formData.startDate"
                                        :validationGroup="'edit'"
                                        ref="reasonDocuments"
                                    />
                                    <!-- Reason Documents -->

                                    <!-- Contract Type -->
                                    <div class="form-group selectTypeContract" v-if="handledFields.contractType">
                                        <label class="required-field-asterisks" for="contractType">
                                            Type de contrat
                                        </label>
                                        <select
                                            id="contractType"
                                            class="form-control select2"
                                            style="width: 100%;"
                                            data-live-search="true"
                                            v-model="formData.contractTypeId"
                                        >
                                            <option
                                                v-for="contractType in contractTypes"
                                                :key="contractType.id"
                                                :value="contractType.id"
                                            >
                                                {{ contractType.title }}
                                            </option>
                                        </select>
                                        <FormError
                                            error="Veuillez choisir le type de contrat"
                                            v-if="!$v.formData.contractTypeId.$error && $v.formData.contractTypeId.$dirty"
                                        />
                                    </div>
                                    <!-- Contract Type -->

                                    <!-- Exemption start date -->
                                    <div class="form-group">
                                        <label for="startDate">Date de début de la dispense</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                            <masked-input
                                                type="text"
                                                id="startDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.startDate.$error }"
                                                @input="maskedDelayTouch($v.formData.startDate)"
                                                v-model="formData.startDate"
                                            />
                                        </div>
                                        <FormError
                                            error="Veuillez renseigner une date comprise entre aujourd’hui moins un an et aujourd'hui plus un an"
                                            v-if="!$v.formData.startDate.isValidDateRange"
                                        />
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.startDate.validDate && $v.formData.startDate.$dirty"
                                        />
                                    </div>

                                    <!-- Deadline date -->
                                    <div class="form-group">
                                        <label for="deadline" class="required-field-asterisks">
                                            Formulaire à remplir avant le
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt" />
                                                </span>
                                            </div>
                                            <masked-input
                                                type="text"
                                                id="deadline"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.deadlineDate.$error }"
                                                @input="maskedDelayTouch($v.formData.deadlineDate)"
                                                v-model="formData.deadlineDate"
                                            />
                                        </div>
                                        <FormError
                                            error="Veuillez renseigner une date supérieure à aujourd’hui"
                                            v-if="!$v.formData.deadlineDate.sameOrAfter"
                                        />
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.deadlineDate.validDate && $v.formData.deadlineDate.$dirty"
                                        />
                                        <FormError
                                            error="Veuillez renseigner la date "
                                            v-if="!$v.formData.deadlineDate.required && $v.formData.deadlineDate.$dirty"
                                        />
                                        <FormError
                                            error="L'année indiquée n'est pas correcte"
                                            v-if="!$v.formData.deadlineDate.isValidDateYear && $v.formData.deadlineDate.$dirty"
                                        />
                                    </div>
                                    <!-- Deadline date -->

                                    <!-- DUE date -->
                                    <div class="form-group" v-if="this.handledFields.dueDate">
                                        <label for="dueDate" class="required-field-asterisks">
                                            Date de la décision unilatérale de l'employeur (DUE)
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt" />
                                                </span>
                                            </div>
                                            <masked-input
                                                type="text"
                                                id="dueDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.dueDate.$error }"
                                                @input="maskedDelayTouch($v.formData.dueDate)"
                                                v-model="formData.dueDate"
                                            />
                                        </div>
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.dueDate.validDate && $v.formData.dueDate.$dirty"
                                        />
                                        <FormError
                                            error="Veuillez renseigner la date"
                                            v-if="!$v.formData.dueDate.required && $v.formData.dueDate.$dirty"
                                        />
                                        <FormError
                                            error="L'année indiquée n'est pas correcte"
                                            v-if="!$v.formData.dueDate.isValidDateYear && $v.formData.dueDate.$dirty"
                                        />
                                    </div>
                                    <!-- DUE date -->

                                    <!-- Guaranty Effective Date -->
                                    <div class="form-group">
                                        <label for="guarantyEffectiveDate" class="required-field-asterisks">
                                            Date d'entrée en vigueur des garanties
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt" />
                                                </span>
                                            </div>
                                            <masked-input
                                                type="text"
                                                id="guarantyEffectiveDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.guarantyEffectiveDate.$error }"
                                                @input="maskedDelayTouch($v.formData.guarantyEffectiveDate)"
                                                v-model="formData.guarantyEffectiveDate"
                                            />
                                        </div>
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.guarantyEffectiveDate.validDate && $v.formData.guarantyEffectiveDate.$dirty"
                                        />
                                        <FormError
                                            error="Veuillez renseigner la date "
                                            v-if="!$v.formData.guarantyEffectiveDate.required && $v.formData.guarantyEffectiveDate.$dirty"
                                        />
                                        <FormError
                                            error="L'année indiquée n'est pas correcte"
                                            v-if="!$v.formData.guarantyEffectiveDate.isValidDateYear && $v.formData.guarantyEffectiveDate.$dirty"
                                        />
                                    </div>
                                    <!-- Guaranty Effective Date -->

                                    <!-- Employment Date -->
                                    <div class="form-group" v-if="enterpriseSettings && enterpriseSettings.employmentDateHandled">
                                        <label for="employmentDate">
                                            Date d'entrée dans l'entreprise du salarié
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="far fa-calendar-alt" />
                                                </span>
                                            </div>
                                            <masked-input
                                                type="text"
                                                id="employmentDate"
                                                mask="11/11/1111"
                                                class="form-control float-right"
                                                :class="{ 'is-invalid': $v.formData.employmentDate.$error }"
                                                @input="maskedDelayTouch($v.formData.employmentDate)"
                                                v-model="formData.employmentDate"
                                            />
                                        </div>
                                        <FormError
                                            error="Format de date incorrect"
                                            v-if="!$v.formData.employmentDate.validDate && $v.formData.employmentDate.$dirty"
                                        />
                                        <FormError
                                            error="Veuillez renseigner la date "
                                            v-if="!$v.formData.employmentDate.required && $v.formData.employmentDate.$dirty"
                                        />
                                        <FormError
                                            error="L'année indiquée n'est pas correcte"
                                            v-if="!$v.formData.employmentDate.isValidDateYear && $v.formData.employmentDate.$dirty"
                                        />
                                    </div>
                                    <!-- Employment Date -->
                                </form>
                            </div>
                        </div>
                        <div class="col-md-4 col-xl-3 info-card">
                            <div v-if="createLegalInformation">
                                <div class="intro">{{ createLegalInformation.requestDescription }}</div>
                                <div
                                    v-for="(paragraph, index) in createLegalInformation.requestItems"
                                    :key="index"
                                    :class="{ 'intro-item-2': index === 0, 'intro-item-1': index > 0 }"
                                >
                                    {{ paragraph }}
                                </div>
                            </div>
                            <img src="@/assets/img/orangePill.svg" class="orangePill" alt="">
                        </div>

                        <div class="input-group col-md-10 mx-sm-auto my-md-4">
                            <button
                                class="btn btn-success btn-lg linktoemployee"
                                :disabled="isButtonDisabled"
                                @click.prevent="sendLink"
                            >
                                <span>Envoyer le lien au salarié</span>
                                <span
                                    v-if="sendLinkLoading"
                                    class="spinner-border spinner-border-sm ml-2"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </button>
                            <button
                                class="btn btn-primary btn-lg savepdf"
                                :disabled="isButtonDisabled"
                                @click.prevent="downloadPdf"
                            >
                                <span>Enregistrer et télécharger le PDF</span>
                                <span
                                    v-if="downloadPdfLoading"
                                    class="spinner-border spinner-border-sm ml-2"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { required, email, maxLength } from 'vuelidate/lib/validators';
    import MaskedInput from 'vue-masked-input';

    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import FormError from '../../components/FormError';
    import ReasonDocuments from '../../components/ReasonDocuments';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import ExemptionHandleReasonChangeMixin from '../../mixins/exemptionHandleReasonChangeMixin';
    import Header from '../../components/Header';
    import { createExemptionFormData } from '../../service/form/exemptionCreate';
    import {
      phoneNumberConstraint,
      validDateConstraint,
      dateSameOrAfterConstraint,
      isValidDateYearConstraint,
      dateInOneYearRange,
    } from '../../utils/validation';
    import {
        fetchCreateLegalInformation,
        fetchContactTypes,
        fetchPartialBeneficiaries,
        sendEmailToEmployee,
        downloadExemption,
        fetchExemptionById,
        updateToRenewExemption
    } from '../../service/api/exemptions.api';
    import { filterRenewReasons } from '../../utils/utils';
    import ExemptionManager from "../../service/manager/exemptionManager";

    export default {
        mixins: [ValidationDelayTouch, ExemptionHandleReasonChangeMixin],
        data() {
            return {
                formData: JSON.parse(JSON.stringify(createExemptionFormData)),
                chosenReason: null,
                downloadPdfLoading: false,
                sendLinkLoading: false,
                exemption: null,
                beneficiaries: [],
                reasons: [],
                effectiveDues: [],
                isRenew: true,
                civilityInitiallyEmpty: false,
            };
        },
        computed: {
            ...mapGetters({
                contractTypes: 'contractTypes',
                createLegalInformation: 'createLegalInformation',
                enterpriseUuid: 'enterpriseUuid',
                exemptionRenewReasons: 'exemptionRenewReasons',
                filteredExemptionRenewReasons: 'filteredExemptionRenewReasons',
                enterpriseSettings: 'enterpriseSettings',
                civilities: 'civilities',
            }),
            reason() {
                return this.formData.exemptionReason.reasonId;
            },
            particularCaseFilteredReasons() {
                return filterRenewReasons(this.exemption, this.exemptionRenewReasons);
            },
            exemptionId() {
                return this.$route.params.exemptionId;
            },
            handledFields() {
                const { contractTypeHandled: contractType = false, sector, employmentDateHandled: employmentDate = false } = this.enterpriseSettings || {};
                return { contractType, beneficiary: sector !== 'public', dueDate: sector !== 'public', employmentDate };
            },
            isButtonDisabled() {
                return this.$v.$invalid
                    || this.$refs.reasonDocuments.$v.$invalid
                    || this.sendLinkLoading
                    || this.downloadPdfLoading
                ;
            },
            isGeneralInformationLocked() {
                return !this.exemption || this.exemption.courseType === 'token';
            }
        },
        watch: {
            reason(reasonId) {
                if (!Number.isInteger(reasonId)) {
                    this.chosenReason = null;
                    return;
                }
                this.fetchChosenReason(reasonId);
            },
        },
        async created () {
            await this.fetchExemption();
            this.beneficiaries = await fetchPartialBeneficiaries();
            await this.fetchExemptionRenewReasons({ exemptionId: this.exemptionId, enterpriseUuid: this.enterpriseUuid });
            await this.fetchStructures();
            await fetchCreateLegalInformation(this.exemptionRenewReasons[0].id);
            await fetchContactTypes();
            await this.fetchReasons(this.isRenew);
            await this.fetchCivilities();
        },
        beforeDestroy() {
            this.chosenReason = null;
            this.formData = JSON.parse(JSON.stringify(createExemptionFormData));
            this.$nextTick(() => { this.$v.$reset() });
        },
        methods: {
            ...mapActions({
                fetchBaseReasons: 'fetchBaseReasons',
                fetchExemptionRenewReasons: 'fetchExemptionRenewReasons',
                fetchCivilities: 'fetchCivilities'
            }),
            async sendLink() {
                this.sendLinkLoading = true;
                try {
                    const { data } = await updateToRenewExemption(this.exemptionId, this.formData);
                    await sendEmailToEmployee(data.id);
                    this.sendLinkLoading = false;
                    await this.$router.push({ name: 'exemption-list'});
                } catch ({ response }) {
                    this.sendLinkLoading = false;
                }
            },
            async downloadPdf() {
                this.downloadPdfLoading = true;
                try {
                    const { data } = await updateToRenewExemption(this.exemptionId, this.formData);
                    await downloadExemption(data.id);
                    this.downloadPdfLoading = false;
                    await this.$router.push({ name: 'exemption-list'});
                } catch ({ response }) {
                    this.downloadPdfLoading = false;
                }
            },
            async fetchExemption() {
                const { data } = await fetchExemptionById(this.exemptionId);
                this.exemption = data;
                await this.$store.dispatch('setSettingsContext', { enterpriseUuid: data.enterprise.uuid });
                this.formData = {
                    ...this.formData,
                    ... await ExemptionManager.createRenewFormData(data)
                }
                this.civilityInitiallyEmpty = !this.formData.civility;
            },
        },
        validations() {
            return {
                formData: {
                    civility: {
                        required,
                        maxLength: maxLength(20),
                    },
                    firstName: {
                        required,
                    },
                    lastName: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    phoneNumber: {
                        phoneLength: phoneNumberConstraint,
                    },
                    birthDate: {
                        validDate: validDateConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                    },
                    startDate: {
                        validDate: validDateConstraint,
                        isValidDateRange: dateInOneYearRange,
                        isValidDateYear: isValidDateYearConstraint
                    },
                    deadlineDate: {
                        required,
                        validDate: validDateConstraint,
                        sameOrAfter: dateSameOrAfterConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                    },
                    ...(this.handledFields.beneficiary && {
                        beneficiaryId: {
                            required
                        },
                    }),
                    ...(this.handledFields.contractType && {
                        contractTypeId: {
                            required
                        },
                    }),
                    ...(this.handledFields.dueDate && {
                        dueDate: {
                            required,
                            validDate: validDateConstraint,
                            isValidDateYear: isValidDateYearConstraint,
                        }
                    }),
                    guarantyEffectiveDate: {
                        required,
                        validDate: validDateConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                    },
                    ...(this.handledFields.employmentDate && {
                        employmentDate: {
                            validDate: validDateConstraint,
                            isValidDateYear: isValidDateYearConstraint,
                        },
                    }),
                },
            };
        },
        components: {
            Sidebar,
            Footer,
            ReasonDocuments,
            MaskedInput,
            FormError,
            Header
        }
    }
</script>
